import React, { useEffect, useState } from "react";
import "./LaunchGate.css";

// const LAUNCH_DATE = new Date(
//     Date.now() + 20 * 1000
// );

const LAUNCH_DATE = new Date(
    "2026-10-11T10:15:00+05:30"
);

const LaunchGate = ({ onOpen }) => {

    const [isLaunched, setIsLaunched] = useState(false);
    const [isOpening, setIsOpening] = useState(false);

    const calculateTimeLeft = () => {
        const difference =
            LAUNCH_DATE.getTime() - Date.now();

        if (difference <= 0) {
            return {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            };
        }

        return {
            days: Math.floor(
                difference / (1000 * 60 * 60 * 24)
            ),

            hours: Math.floor(
                (difference / (1000 * 60 * 60)) % 24
            ),

            minutes: Math.floor(
                (difference / (1000 * 60)) % 60
            ),

            seconds: Math.floor(
                (difference / 1000) % 60
            )
        };
    };

    const [timeLeft, setTimeLeft] = useState(
        calculateTimeLeft()
    );


    useEffect(() => {

        const timer = setInterval(() => {

            const now = Date.now();

            if (
                now >= LAUNCH_DATE.getTime()
            ) {
                setIsLaunched(true);
                clearInterval(timer);
                return;
            }

            setTimeLeft(
                calculateTimeLeft()
            );

        }, 1000);

        return () => clearInterval(timer);

    }, []);


    const formatNumber = (number) =>
        String(number).padStart(2, "0");


    const handleOpen = () => {

        if (!isLaunched || isOpening) {
            return;
        }

        setIsOpening(true);

        setTimeout(() => {

            localStorage.setItem(
                "purecarats_launch_opened",
                "true"
            );

            onOpen();

        }, 1900);
    };


    return (
        <div
            className={`launch-gate ${isOpening
                    ? "launch-gate-opening"
                    : ""
                }`}
        >

            {/* Ambient background */}
            <div className="launch-ambient-glow" />

            {/* Storefront */}
            <div className="launch-storefront">

                {/* PURECARATS LOGO */}
                <div className="launch-brand">
                    <img
                        src="/logo/logo-name.svg"
                        alt="Purecarats"
                    />
                </div>

                <div className="launch-brand-line" />


                {/* Main entrance */}
                <div className="luxury-entrance">

                    {/* Outer arch */}
                    <div className="entrance-arch">

                        <div className="arch-inner" />

                    </div>


                    {/* Left side architecture */}
                    <div className="entrance-side entrance-side-left">

                        <div className="side-light" />

                        <div className="side-panel" />

                    </div>


                    {/* Right side architecture */}
                    <div className="entrance-side entrance-side-right">

                        <div className="side-light" />

                        <div className="side-panel" />

                    </div>


                    {/* Doors */}
                    <div className="luxury-doors">

                        {/* Left door */}
                        <div className="luxury-door luxury-door-left">

                            <div className="door-panel">
                                <div className="door-ribs" />
                                <div className="door-border" />
                            </div>

                        </div>


                        {/* Right door */}
                        <div className="luxury-door luxury-door-right">

                            <div className="door-panel">
                                <div className="door-ribs" />
                                <div className="door-border" />
                            </div>

                        </div>


                        {/* Door handles */}
                        <div className="door-handle door-handle-left">
                            <span />
                        </div>

                        <div className="door-handle door-handle-right">
                            <span />
                        </div>


                        {/* Door content */}
                        <div className="door-content">

                            {!isLaunched ? (

                                <>
                                    <div className="launch-eyebrow">
                                        SOMETHING BEAUTIFUL
                                    </div>

                                    <h1>
                                        IS COMING
                                    </h1>

                                    <div className="launch-divider" />

                                    <div className="launching-label">
                                        DOORS OPENING IN
                                    </div>


                                    <div className="launch-countdown">

                                        <div className="countdown-unit">
                                            <strong>
                                                {formatNumber(
                                                    timeLeft.days
                                                )}
                                            </strong>

                                            <span>
                                                DAYS
                                            </span>
                                        </div>


                                        <div className="countdown-unit">
                                            <strong>
                                                {formatNumber(
                                                    timeLeft.hours
                                                )}
                                            </strong>

                                            <span>
                                                HOURS
                                            </span>
                                        </div>


                                        <div className="countdown-unit">
                                            <strong>
                                                {formatNumber(
                                                    timeLeft.minutes
                                                )}
                                            </strong>

                                            <span>
                                                MINUTES
                                            </span>
                                        </div>


                                        <div className="countdown-unit">
                                            <strong>
                                                {formatNumber(
                                                    timeLeft.seconds
                                                )}
                                            </strong>

                                            <span>
                                                SECONDS
                                            </span>
                                        </div>

                                    </div>
                                </>

                            ) : (

                                <>
                                    <div className="launch-eyebrow">
                                        THE WAIT IS OVER
                                    </div>

                                    <h1>
                                        PURECARATS
                                        <br />
                                        IS LIVE
                                    </h1>

                                    <div className="launch-divider" />

                                    <button
                                        className="open-purecarats"
                                        onClick={handleOpen}
                                    >
                                        VISIT PURECARATS
                                        <span>→</span>
                                    </button>
                                </>

                            )}

                        </div>

                    </div>

                </div>


                {/* Bottom */}
                <div className="launch-tagline">
                    TIMELESS DIAMONDS · MODERN YOU
                </div>

            </div>

        </div>
    );
};

export default LaunchGate;